import Select from "react-select";
import Drawer from 'react-modern-drawer';
import { FormGroup, Input, Label } from "reactstrap";
import { useTranslation } from "react-i18next";
import SelectCustomStyles from "../../../../../utils/styles/reactSelect";
import { useState, useEffect } from "react";
import DefaultButton from "../../../../../components/Buttons/Default";
import { post } from "../../../../../utils/helpers/api";
import { toast } from "react-toastify";
import countries from "../../../../../data/countries";

function AddAddressDrawer({ isOpen, toggle, isNew, customerData, editData, onSaved, onLocalSave }) {
  const { t } = useTranslation();
  const [saveLoading, setSaveLoading] = useState(false);
  const [addressData, setAddressData] = useState({
    label: '',
    street: '',
    city: '',
    state: '',
    postal_code: '',
    country: ''
  });

  useEffect(() => {
    setAddressData({
      label: editData?.label || '',
      street: editData?.street || '',
      city: editData?.city || '',
      state: editData?.state || '',
      postal_code: editData?.postal_code || '',
      country: editData?.country || ''
    });
  }, [editData, isOpen]);

  const saveAddress = async () => {
    if (isNew) {
      onLocalSave?.({ ...addressData, _tempId: editData?._tempId });
      toggle();
      return;
    }

    setSaveLoading(true);
    const url = editData ? '/crm/customers/addresses/update/'+editData.id : '/crm/customers/addresses/store/'+customerData.id;
    const data = await post(url, { ...addressData });

    if(data.success) {
      toggle();
      onSaved?.();
    } else {
      toast.error(data.message || t('common.somethingWentWrong'));
    }
    setSaveLoading(false);
  }

  return(
    <Drawer
      open={isOpen}
      onClose={toggle}
      direction="right"
      size={'50%'}
      enableOverlay={true}
      lockScroll={true}
      zIndex={9000}
      duration={200}
    >
      <div className="p-3">
        <h4 className="fw-bold">
          {editData ? t('common.edit') + ' ' + t('common.address') : t('crm.newAddress')}
        </h4>

        <FormGroup>
          <Label>{t('inventory.label')} </Label>
          <Input
            value={addressData.label}
            onChange={(e) => setAddressData({ ...addressData, label: e.target.value })}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('address.street')} </Label>
          <Input
            value={addressData.street}
            onChange={(e) => setAddressData({ ...addressData, street: e.target.value })}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('address.city')} </Label>
          <Input
            value={addressData.city}
            onChange={(e) => setAddressData({ ...addressData, city: e.target.value })}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('address.state')} </Label>
          <Input
            value={addressData.state}
            onChange={(e) => setAddressData({ ...addressData, state: e.target.value })}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('address.zipCode')} </Label>
          <Input
            value={addressData.postal_code}
            onChange={(e) => setAddressData({ ...addressData, postal_code: e.target.value })}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('address.country')} </Label>
          <Select
            value={countries.map(c => ({ value: c.slug, label: c.name })).find(o => o.value === addressData.country) || null}
            onChange={(selected) => setAddressData({ ...addressData, country: selected ? selected.value : '' })}
            options={
              countries.map((country) => (
                { value: country.slug, label: country.name }
              ))
            }
            styles={SelectCustomStyles}
          />
        </FormGroup>

        <DefaultButton
          color="primary"
          size="sm"
          disabled={saveLoading}
          loading={saveLoading}
          onClick={saveAddress}
        >{t('common.save')}</DefaultButton>
      </div>
    </Drawer>
  );
}

export default AddAddressDrawer;
